<template>
  <el-form
    :inline="true"
    :model="formData"
    class="margin-bottom-xs"
    @keydown.enter="onSubmit('search')"
    :rules="rules"
  >
    <el-form-item
      v-for="(item, index) in formList"
      :key="index"
      :label="item.label"
      :prop="item.prop"
    >
      <!-- 选择项 -->
      <el-select
        v-model="formData[item.prop]"
        :placeholder="item.placeholder || '请选择' + item.label"
        clearable
        @change="changeValue"
        v-if="item.type === 'select'"
      >
        <el-option
          v-for="option in getOptions(item)"
          :key="option.value"
          :label="option.label"
          :value="option.value"
        />
      </el-select>
      <!-- 日期 -->
      <el-date-picker
        v-model="formData[item.prop]"
        :type="item.type"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        v-else-if="['datetimerange', 'daterange'].includes(item.type)"
        :default-time="item.defaultTime || defaultTime"
        @change="changeValue"
        value-format="YYYY-MM-DD HH:mm:ss"
        format="YYYY-MM-DD HH:mm:ss"
      />
      <el-input
        v-model="formData[item.prop]"
        :placeholder="item.placeholder || '请输入' + item.label"
        clearable
        @change="changeValue"
        v-else
        style="width: 200px"
      />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit('search')">查询</el-button>
      <el-button @click="onSubmit('reset')">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import dict from './dict'
export default {
  props: {
    formList: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formData: {},
      defaultTime: [new Date().setHours(0, 0, 0), new Date().setHours(23, 59, 59)],
      defaultDate: {}
    }
  },
  computed: {
    getOptions () {
      return item => {
        if (item.dict) {
          return dict[item.dict]
        } else if (item.options) {
          return item.options
        } else {
          return []
        }
      }
    }
  },
  mounted () {
    // 初始默认值
    this.defaultFn()
  },
  methods: {
    defaultFn () {
      this.formList.forEach(item => {
        this.formData[item.prop] = this.value[item.prop] || ''
      })
      this.defaultDate = JSON.parse(JSON.stringify(this.formData))
    },
    onSubmit (type) {
      if (type === 'reset') {
        this.formData = this.defaultDate
      }
      this.$emit('search', type, this.formData)
    },
    changeValue () {
      this.$emit('change', this.formData)
    }
  }
}
</script>
